import { EyeOutlined } from '@ant-design/icons';
import { RichiestaDTO } from '@framework/api-client';
import { generatePath, Link } from '@framework/ui';
import { Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

export interface ISubmissionViewTableButtonProps {
  record: RichiestaDTO;
  isMobile?: boolean | null;
}

/**
 * Pulsante "visualizza il dettaglio della richiesta" all'interno della tabella delle richieste
 */
export function SubmissionViewTableButton(
  props: ISubmissionViewTableButtonProps,
) {
  const { record, isMobile } = props;

  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Link
      title={t(
        'submission-list.apri-pagina-dettaglio-richiesta',
        'Apri la pagina di dettaglio della richiesta',
      )}
      to={
        theme.redirectToFirstModule
          ? generatePath('/richieste/:id/modulo-principale', {
              id: record.id ?? '<unknown>',
            })
          : generatePath('/richieste/:id', { id: record.id ?? '<unknown>' })
      }
    >
      <Tooltip
        title={t(
          'submission-list.visualizza-richiesta',
          'Visualizza richiesta',
        )}
      >
        <EyeOutlined
          aria-hidden={!isMobile}
          aria-label="Visualizza richiesta"
        />
      </Tooltip>
    </Link>
  );
}
